module.exports = __webpack_public_path__ + "static/media/image_29.0b0c2154.png";